/**
 * AdsHubPage — vereinte «Anzeigen»-Seite: Tab 1 Google Ads, Tab 2 Meta (Facebook & Instagram),
 * Tab 3 Autopilot-Historie (woechentliche KI-Analysen beider Kanaele).
 * Erreichbar unter /anzeigen; /google-ads und /ads-manager öffnen direkt den passenden Tab.
 */
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import GoogleAdsPage from "./GoogleAdsPage";
import AdsManagerPage from "./AdsManagerPage";
import AutopilotHistory from "@/components/AutopilotHistory";

export default function AdsHubPage() {
  const location = useLocation();
  const initial = location.pathname === "/ads-manager" ? "meta" : "google";
  const [tab, setTab] = useState(initial);

  return (
    <div data-testid="ads-hub-page">
      <div className="px-6 pt-5">
        <h1 className="text-2xl font-bold mb-3">Anzeigen</h1>
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList data-testid="ads-hub-tabs">
            <TabsTrigger value="google" data-testid="ads-hub-tab-google">Google</TabsTrigger>
            <TabsTrigger value="meta" data-testid="ads-hub-tab-meta">Facebook & Instagram</TabsTrigger>
            <TabsTrigger value="autopilot" data-testid="ads-hub-tab-autopilot">🤖 Autopilot-Historie</TabsTrigger>
          </TabsList>
          <TabsContent value="google" className="-mx-6">
            <GoogleAdsPage />
          </TabsContent>
          <TabsContent value="meta" className="-mx-6">
            <AdsManagerPage />
          </TabsContent>
          <TabsContent value="autopilot" className="-mx-6">
            <AutopilotHistory />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
